'use client'

import React, { ComponentProps, FC, useEffect, useState } from 'react'

import clsx from 'clsx'

import { Txt, Icon } from 'src/components/atoms'
import { ActionButton } from 'src/components/molecules/inputs/ActionButton'

import styles from './bulkActionButton.module.scss'

type ActionType = {
  text: string
  iconPath: string
  action: ComponentProps<'button'>['onClick']
}

type Props = {
  isActive: boolean
  actions: ActionType[]
}

export const BulkActionButton: FC<Props> = ({ isActive, actions }) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    !isActive && setIsOpen(false)
  }, [isActive])

  return (
    <div
      className={clsx(
        'tw-fixed tw-bottom-[24px] tw-left-[50%] tw-translate-x-[-50%] tw-duration-300 tw-z-10',
        isActive ? 'tw-translate-y-0' : 'tw-translate-y-[200px]'
      )}
    >
      <div className={styles.shadow}>
        <div className="tw-border-border-primary tw-overflow-hidden tw-flex tw-flex-col tw-rounded-[var(--r1)]">
          {isOpen ? (
            <>
              {actions.map(({ text, iconPath, action }) => (
                <ActionButton
                  key={text}
                  bgColor="white"
                  className="tw-pl-s0 tw-pr-s5"
                  onClick={action}
                >
                  <div className="tw-flex tw-items-center">
                    <Icon
                      size="--r1"
                      path={iconPath}
                      className="tw-mr-r-3 tw-text-standardText-secondary"
                    />
                    <Txt>{text}</Txt>
                  </div>
                </ActionButton>
              ))}

              <ActionButton bgColor="dark" className="tw-pl-s0" onClick={() => setIsOpen(false)}>
                <div className="tw-flex tw-items-center">
                  <Icon size="--r1" path="close/soft/line" className="tw-mr-r-3" />
                  <Txt>閉じる</Txt>
                </div>
              </ActionButton>
            </>
          ) : (
            <ActionButton bgColor="dark" className="tw-px-s1" onClick={() => setIsOpen(true)}>
              <div className="tw-flex tw-items-center">
                <Icon size="--r1" path="more-horizontal/soft/line" className="tw-mr-r-3" />
                <Txt>アクション</Txt>
              </div>
            </ActionButton>
          )}
        </div>
      </div>
    </div>
  )
}
